import request from '@/utils/request';

export async function categoryApi(id) {
  const response = await request.get('/f/category', {
    params: { id }
  });
  return response;
}
